import styled from 'styled-components'

export const SharedWithMeContainer = styled.div`
    padding: 16px;
    min-height: 200px;
`

export const SharedWithMeContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`
